import React, { Component } from 'react';
import { Translate, Row, Col, Card, CardContent, Form, FormField, Select, Input, Button, Seperator, Icon, Modal, H2, ToggleButton, SwitchButton } from '$common';
import CSSModules from 'react-css-modules';
import style from './filters.scss';
import cloneDeep from 'lodash/cloneDeep';
import groupBy from 'lodash/groupBy';
import isEqual from 'lodash/isEqual';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import omit from "lodash/omit";
import AgeGroups from '$constants/age-groups.json';
import { FadeIn } from 'animate-components';

@CSSModules(style, { allowMultiple: true })
export default class Filters extends Component {
  state = {
    isSaveFilterModalOpen: false,
    isInfoModalOpen: false,
    isOtherFiltersOpen: false,
    filterId: this.props.selectedFilter,
    filterName: this.props.selectedFilterName,
    filters: this.props.filters,
    customColumns: [],
    groupedAges: {}
  };

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps, this.props)) {
      let filters = nextProps.filters;
      if (isEqual(nextProps.filters, {})) {
        filters = {
          age_range: {},
          min_age: "",
          max_age: "",
          gender: { male: false, female: false },
          expression: {
            left: {},
            operator: "",
            right: {}
          },
          custom_field_key: "",
          custom_field_value: ""
        };
        this.setState({
          queryBoxes: [],
          expression: "",
          filterId: null,
          filterName: "",
          filters
        })
      } else {
        if (isEqual(nextProps.filters.expression, {})) {
          filters = {
            ...filters,
            expression: {
              left: {},
              operator: "",
              right: {}
            }
          }
        }
        this.setState({ filterId: nextProps.selectedFilter, filterName: nextProps.selectedFilterName, filters });
      }
      this.populateAgeGroups(nextProps.demographics);
      this.normalizeFilters(filters);
    }
  }

  componentWillMount() {
    this.normalizeFilters(this.props.filters);
    this.mergeCustomColumns();
    this.populateAgeGroups(this.props.demographics);
  }

  populateAgeGroups(demographics) {
    let groupedAges = {...AgeGroups};

    Object.keys(AgeGroups).map(group => {
      groupedAges[group] = 0;
    });

    Object.keys(demographics.ages || {}).map(age => {
      const count = demographics.ages[age] || 0;
      Object.keys(AgeGroups).map(group => {
        if (age > AgeGroups[group][0] && age < AgeGroups[group][1]) {
          groupedAges[group] += count;
        }
      });
    });

    this.setState({ groupedAges });
  }

  mergeCustomColumns() {
    const { customColumns } = this.props;
    this.setState({ customColumns: groupBy(customColumns, 'key') });
  }

  submit(filters) {
    const { sendFilters } = this.props;
    let clonedFilters = cloneDeep(filters);

    sendFilters(this.submitFilters(filters, clonedFilters));
  }

  submitFilters(filters, clonedFilters) {
    clonedFilters.age_range = [];
    if (!filters.is_custom_age_range_enabled) {
      Object.keys(filters.age_range).map( group => {
        if (filters.age_range[group]) {
          AgeGroups[group].map(age => {
            clonedFilters.age_range.push(age);
          })
        }
      });

      if (clonedFilters.age_range.length > 0) {
        const min_age = Math.min(...clonedFilters.age_range);
        const max_age = Math.max(...clonedFilters.age_range);
        clonedFilters.age_range = `[${min_age},${max_age}]`;
      } else {
        clonedFilters.age_range = "[0,200]";
      }
    } else {
      clonedFilters.age_range = `[${filters.min_age || 0},${filters.max_age || 200}]`;
    }

    if (filters.gender.male && filters.gender.female || !filters.gender.male && !filters.gender.female) {
      clonedFilters.gender = 'unspecified'
    } else {
      Object.keys(filters.gender).map(gender => {
        if (filters.gender[gender]) {
          clonedFilters.gender = gender;
        }
      })
    }

    if (filters.expression) {
      if (!filters.expression.operator || !filters.expression.left.question_option_id) {
        clonedFilters.expression = {};
      } else {
        if (filters.expression.right) {
          if (!filters.expression.right.question_option_id) {
            delete clonedFilters.expression.right;
          }
        }
      }  
    } else {
      clonedFilters.expression = {};
    }
    

    if (filters.custom_field_key && filters.custom_field_value) {
      clonedFilters.custom_fields = [
        { key: filters.custom_field_key, value: filters.custom_field_value }
      ]
    }

    if (!filters.custom_field_key) delete filters.custom_field_key;
    if (!filters.custom_field_value) delete filters.custom_field_value;

    delete clonedFilters.custom_field_key;
    delete clonedFilters.custom_field_value;
    delete clonedFilters.min_age;
    delete clonedFilters.max_age;

    return clonedFilters;
  }

  normalizeFilters(filters) {
    let clonedFilters = cloneDeep(filters);
    clonedFilters.age_range = {};

    if (filters.age_range) {
      try {
        const age_range = JSON.parse(filters.age_range);
        clonedFilters.min_age = age_range[0];
        clonedFilters.max_age = age_range[1];
        Object.keys(AgeGroups).map(group => {
          if (AgeGroups[group].includes(age_range[0]) || AgeGroups[group].includes(age_range[1])) {
            clonedFilters.age_range[group] = true;
          }
        })
      } catch(e) {
      }
    }

    clonedFilters.gender = { male: false, female: false };
    if (filters.gender) {
      clonedFilters.gender[filters.gender] = true;
    }

    this.setState({ filters: clonedFilters });
  }

  saveFilter(values) {
    const { filters, filterId } = this.state;
    let clonedFilters = cloneDeep(filters);

    if (filterId) {
      this.props.saveFilter({ id: filterId, name: values.title, ...this.submitFilters(filters, clonedFilters) });
    } else {
      this.props.saveFilter({ name: values.title, ...this.submitFilters(filters, clonedFilters) });
    }

    this.setState({ isSaveFilterModalOpen: false })
  }

  ageGroupPercentage(ageGroup) {
    const { demographics } = this.props;
    const { groupedAges } = this.state;
    let totalCount = 0;

    Object.keys(demographics.ages || {}).map(age => totalCount += demographics.ages[age]);

    return (Object.keys(demographics.ages || {}).length > 0 ?
            ((groupedAges[ageGroup] / totalCount) * 100).toFixed(2)
          : 0);
  }

  genderPercentage(gender) {
    const { demographics } = this.props;
    let totalCount = 0;

    Object.keys(demographics.genders || {}).map(gender => totalCount += demographics.genders[gender]);

    return (Object.keys(demographics.genders || {}).length > 0 ?
            ((demographics.genders[gender] / totalCount) * 100).toFixed(2)
          : 0);
  }

  get isSaveFilterButtonActive() {
    const { filters, filterId } = this.state;

    if (filters || filterId) {
      if (filters.min_age !== "" || filters.max_age !== "" || filters.gender !== null || filters.expression !== "") return true;
    }

    return false;
  }

  render() {
    const { questions } = this.props;
    const { isSaveFilterModalOpen, filterId, filterName, filters, customColumns, isOtherFiltersOpen } = this.state;

    return (
      <div styleName="root">
        <Modal
          size="small"
          title={Translate.get('save_filter')}
          isOpen={isSaveFilterModalOpen}
          onCloseRequest={() => this.setState({ isSaveFilterModalOpen: false })}
        >
          <Form onSubmit={values => this.saveFilter(values)} defaults={{ title: filterName }}>
            <FormField label={Translate.get('filter_name')} name="title">
              <Input />
            </FormField>
            <Button type="success" block submit>{Translate.get('save_filter')}</Button>
          </Form>
        </Modal>

        <Card header={
          <Row>
            <Col md="2/3">
              <H2>{Translate.get('filters')} {filterName && ` - ${filterName}`}</H2>
            </Col>
            <Col md="1/3">
              <Button
                block
                size="micro"
                type="weak"
                style={{ marginTop: '-6px' }}
                disabled={!this.isSaveFilterButtonActive}
                onClick={() => this.isSaveFilterButtonActive && this.setState({ isSaveFilterModalOpen: true })}
              >
                {filterId && 'Update' || 'Save'}
              </Button>
            </Col>
          </Row>
        }>
          <CardContent>
            <Form
              onSubmit={values => this.submit(values)}
              defaults={omit(filters, 'expression')}
              overrideValues
              onChange={values => this.setState({ filters: values })}
            >
              <div styleName="age">
                <Seperator
                  size="small"
                  style={{ marginBottom: '30px' }}
                  extraContent={
                    <div styleName="custom-age-range">
                      <FormField name={`is_custom_age_range_enabled`} label={Translate.get('custom')} style={{ margin: '0' }}>
                        <SwitchButton />
                      </FormField>
                    </div>
                  }
                >{Translate.get('age_range')}</Seperator>

                {
                  !filters.is_custom_age_range_enabled ?
                    Object.keys(AgeGroups).map( (item, itemIndex) => (
                      <Tooltip placement="top" overlay={<div>{AgeGroups[item][0]} - {AgeGroups[item][1]}</div>} key={itemIndex}>
                        <div style={{ display: 'inline-block', width: '33.33%', padding: '0 4px' }}>
                          <ToggleButton
                            name={`age_range[${item}]`}
                            label={Translate.get(item)}
                          />
                          <span styleName="percentage">{this.ageGroupPercentage(item)}%</span>
                        </div>
                      </Tooltip>
                    ))
                  :
                    <Row>
                      <Col md="1/2">
                        <FormField name="min_age">
                          <Input type="number" placeholder={Translate.get('min')}/>
                        </FormField>
                      </Col>
                      <Col md="1/2">
                        <FormField name="max_age">
                          <Input type="number" placeholder={Translate.get('max')}/>
                        </FormField>
                      </Col>
                    </Row>
                }
              </div>

              <div styleName="gender">
                <Seperator size="small">{Translate.get('gender')}</Seperator>
                <div styleName="button-wrapper">
                  <ToggleButton
                    name={`gender[male]`}
                    type="white-ghost"
                    selectedType="ghost"
                    label={
                      <img src={require('$shared/images/audience/male.svg')} />
                    }
                  />
                  <span styleName="percentage">{this.genderPercentage('male')}%</span>
                </div>
                <div styleName="button-wrapper">
                  <ToggleButton
                    name={`gender[female]`}
                    type="white-ghost"
                    selectedType="ghost"
                    label={
                      <img src={require('$shared/images/audience/female.svg')} />
                    }
                  />
                  <span styleName="percentage">{this.genderPercentage('female')}%</span>
                </div>
              </div>

              {
                questions || Object.keys(customColumns).length > 0 ?
                  <p styleName="text-button" onClick={() => this.setState({ isOtherFiltersOpen: !isOtherFiltersOpen })}>
                    {
                      !isOtherFiltersOpen ?
                        <span>{Translate.get('show_other_filters')} <Icon name="angle-down" /></span>
                      :
                        <span>{Translate.get('hide_other_filters')} <Icon name="angle-up" /></span>
                    }
                  </p>
                : ''
              }

              {
                isOtherFiltersOpen &&
                <FadeIn>
                  {
                    Object.keys(customColumns).length > 0 &&
                    <div>
                      <Seperator size="small">{Translate.get('custom_fields')}</Seperator>
                      <Row>
                        <Col md="1/2">
                          <FormField label={Translate.get('key')} name="custom_field_key">
                            <Select
                              options={Object.keys(customColumns).map(item => ({ label: item, value: item }))}
                            />
                          </FormField>
                        </Col>
                        <Col md="1/2">
                          <FormField label={Translate.get('value')} name="custom_field_value">
                            <Input />
                          </FormField>
                        </Col>
                      </Row>
                    </div>
                  }
                  {
                    questions &&
                    <div styleName="expression">
                      <Seperator size="small">{Translate.get('filter_by_answers')}</Seperator>
                      <Row>
                        <Col md="1/2">
                          <FormField name="expression[left][question_id]" label={Translate.get('question')}>
                            <Select
                              options={questions.selections.map(({ question_title }, index) => ({ label: `${index+1} - ${question_title}`, value: index }))}
                            />
                          </FormField>
                        </Col>
                        <Col md="1/2">
                          <FormField name="expression[left][question_option_id]" label={Translate.get('answer')}>
                            <Select
                              options={
                                filters.expression ?
                                  filters.expression.left ?
                                    typeof filters.expression.left.question_id === "number" ?
                                      questions.selections[filters.expression.left.question_id].selections.map((option, index) =>
                                        ({ label: `${index+1} - ${option.label}`, value: option.id })
                                      )
                                      : []
                                    : []
                                  : []
                              }
                            />
                          </FormField>
                        </Col>
                      </Row>
                      <div styleName={`operators ${filters.expression && filters.expression.left && ((filters.expression.left.question_option_id && 'active') || '') || ''}`}>
                        {
                          filters.expression &&
                          ['and', 'or', 'not'].map((i, index) => (
                            <Button
                              type={filters.expression.operator === i && 'weak' || 'default'}
                              size="small"
                              onClick={() => {
                                filters.expression.operator = filters.expression.operator !== i && i || "";
                                this.setState({ filters });
                              }}
                              key={index}
                            >{i}</Button>
                          ))
                        }
                      </div>
                      {
                        filters.expression &&
                        filters.expression.left &&
                        filters.expression.left.question_option_id && filters.expression.operator !== "not" &&
                        <Row>
                          <Col md="1/2">
                            <FormField name="expression[right][question_id]" label={Translate.get('question')}>
                              <Select
                                options={questions.selections.map(({ question_title }, index) => ({ label: `${index+1} - ${question_title}`, value: index }))}
                              />
                            </FormField>
                          </Col>
                          <Col md="1/2">
                            <FormField name="expression[right][question_option_id]" label={Translate.get('answer')}>
                              <Select
                                options={
                                  filters.expression.right ?
                                    typeof filters.expression.right.question_id === "number" ?
                                      questions.selections[filters.expression.right.question_id].selections.map((option, index) =>
                                        ({ label: `${index+1} - ${option.label}`, value: option.id })
                                      )
                                      : []
                                    : []
                                }
                              />
                            </FormField>
                          </Col>
                        </Row>
                      }
                    </div>
                  }
                </FadeIn>
              }

              <Row>
                <Col md="1/2">
                  <Button type="success" block submit>{Translate.get('apply')}</Button>
                </Col>
                <Col md="1/2">
                  <Button type="ghost" block onClick={() => this.props.clearSelection()}>{Translate.get('clear_filter')}</Button>
                </Col>
              </Row>
            </Form>
          </CardContent>
        </Card>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/project/insights/filters/filters.js